
export const omInspectionGisFieldsObject ={
    objectId:{name: "OBJECTID", mandatory: true},
    inspector:{
        name: "Inspector",
        mandatory:true,

    },
    estimatedWorkQuantity: {
        name: "EstimatedWorkQuantity",
        mandatory: true,
    },
    workUnit: {
        name: "WorkUnit",
        mandatory: true,
    },
    deficiencyLocation: {
        name: "DeficiencyLocation",
        mandatory: true,
    },
    repairRecommendation: {
        name: "RepairRecommendation",
        mandatory: true,
    },
    propertyName: {
        name: "PropertyName",
        mandatory: true,
    },
    locationCode: {
        name: "LocationCode",
        mandatory: true,
    },

    dimensions: {
        name: "Dimensions",
        mandatory: false,
    },
    workCode: {
        name: "WorkCode",
        mandatory: true,
    },
    latitude: {
        name: "Latitude",
        mandatory: false,
    },
    longitude: {
        name: "Longitude",
        mandatory: false,
    },
    locationDescription: {
        name: "LocationDescription",
        mandatory: false,
    },
    thomasGuide: {
        name: "ThomasGuide",
        mandatory: false,
    },
    caseNumber: {
        name: "CaseNumber",
        mandatory: false,
    },
    inspectorContact: {
        name: "InspectorContact",
        mandatory: false,
    },
    inspectorPhone: {
        name: "InspectorPhone",
        mandatory: false,
    },
    inspectorEmail: {
        name: "InspectorEmail",
        mandatory: false,
    },
    packageId: {
        name: "PCKGID",
        mandatory: false,  
    },
    status: {
        name: "Status",
        mandatory: false,
    },
    
}